// extracted by mini-css-extract-plugin
export default {"row":"Phase_row__k9BlT","col1":"Phase_col1__diaRj","col2":"Phase_col2__+UMfV","required":"Phase_required__cHaCr"};